"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalespersonStatus = exports.StorefrontItemsVisibility = void 0;
var StorefrontItemsVisibility;
(function (StorefrontItemsVisibility) {
    StorefrontItemsVisibility["AllItems"] = "ALL_ITEMS";
    StorefrontItemsVisibility["SpecificItems"] = "SPECIFIC_ITEMS";
})(StorefrontItemsVisibility || (exports.StorefrontItemsVisibility = StorefrontItemsVisibility = {}));
var SalespersonStatus;
(function (SalespersonStatus) {
    SalespersonStatus["Active"] = "ACTIVE";
    SalespersonStatus["Inactive"] = "INACTIVE";
})(SalespersonStatus || (exports.SalespersonStatus = SalespersonStatus = {}));
//# sourceMappingURL=salesperson.js.map